import Page             from "./Page";
import Home             from "./Home";
import Recipe           from "./Recipe";
import Episode          from "./Episode";



class Main
{
	constructor ()
	{


		console.info( 'JS compiled at %c' + __MIX_COMPILATION_DATE__, 'background: green;' );


		switch ( PAGE_NAME )
		{
			case 'home':
				new Home();
				break;
			case 'recipe_details':
				new Recipe();
				break;
			case 'episode':
			case 'episode episode-single':
			case 'episode episode-single ':
				new Episode();
				break;
			default:
				new Page();
				break;
		}
	}


}

// import './MapToggler';
/**
 * 2024-06-05 Switched to a dropdown
 */
import './MapDropwdown';
import './NormalSeasonDropdown';
import './EpisodeAccordion';
import './RecipeTagsDropdown';


function ready ( callbackFunc )
{
	if ( document.readyState !== 'loading' )
	{
		// Document is already ready, call the callback directly
		callbackFunc();
	} else if ( document.addEventListener )
	{
		// All modern browsers to register DOMContentLoaded
		document.addEventListener( 'DOMContentLoaded', callbackFunc );
	} else
	{
		// Old IE browsers
		document.attachEvent( 'onreadystatechange', function ()
		{
			if ( document.readyState === 'complete' )
			{
				callbackFunc();
			}
		} );
	}
}


ready( function ()
{


	new Main();

} );


